import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { GoodsPhoto } from '../../js/ComponentManager'
import { DotLottiePlayer } from '@dotlottie/react-player';
import '@dotlottie/react-player/dist/index.css';
import loading from '../../js/loading.json';

export class SimilarSearch extends Component {
    static displayName = SimilarSearch.name;
    
    constructor(props) {
        super(props);
        this.state = {
            Uid: "",
            Goods_No: "",
            ShopName: "",
            showLoading: false,
            ProductName: "",
            ImageUrl: "",
            SimilarList:[]
        };
        this.refSimilarSearch = React.createRef();
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);

    }
    //초기화
    componentDidMount() {
    }
    //SimilarConfirm ref 함수
   async Search_Goods(Uid, Goods_No, ShopName, ProductName, ImageUrl) {
        this.setState({
            Uid: Uid,
            Goods_No: Goods_No,
            ShopName: ShopName,
            ProductName: ProductName,
            ImageUrl: ImageUrl,
            SimilarList: [],
            showLoading:true
        });

       Big3Common.ModalAlert(bootstrap, this.props.id);

       //달파 AI 검색
       const response = await Big3Common.SimilarPost(ImageUrl);
       if (response.status && response.Data.length>0) {
           const DalpahaData = response.Data;
           //file_no를 이용한 위한 배열값 생성
           const ParamArrayData = DalpahaData
               .filter(item => parseFloat(item.similarity) >= parseFloat(Big3Common.WebConfig.SimilarRatio))
               .map(item => item.image_id);

           if (ParamArrayData.length === 0) {
               this.setState({
                   showLoading: false
               });
               return false;
           }
           //로그기록
           Big3Common.RegisterTrackingLog({
               [Big3Common.ContentState.Page_cd]: "SG",
               [Big3Common.ContentState.Basket_Yn]: "N"
           });

           //클로디 이미지 조회
           const DataList = await Big3Common.Post("api/Search/Similar/GetSimilarGooodsList", {
               data: ParamArrayData,
               uid: this.state.Uid,
               goods_no: this.state.Goods_No
           });
           if (DataList.codeName === Big3Common.ResultCode.Success) {
               const ImageList = JSON.parse(DataList.dataTable);
               //조회된 이미지에 similarity비율 적용
               const mergedList = ImageList.map(imageItem => {
                   const matchingData = DalpahaData.find(dataItem => dataItem.image_id === imageItem.image_id);
                   return {
                       ...imageItem,
                       similarity: matchingData ? parseFloat(matchingData.similarity) : 0   
                   };
               });
               const sortedList = mergedList.sort((a, b) => b.similarity - a.similarity);
               this.setState({
                   showLoading: false,
                   SimilarList: sortedList
               });
           }
           else {
               this.setState({
                   showLoading: false
               });
           }
          
       }
       else {
           alert("AI 유사상품 찾기 장애가 발생 했습니다.");
           return false;
       }
       
    }
    //상세 이미지 보기
    async handleGoodsDtl_Click(e, list) {
                
 
        //await this.refGoodsDtl.current.refCallGoodsData(list.goods_no, list.uid, this.props.id);
        ////pathname이 아래와 같을때 헤더를 지워야 하는 상황이 발생함.
        const validPaths = ["/mypage/bookmark/index",
            "/search/goods/index",
            "/admgr/listgoodsmore",
            "/admgr/sepecialevent",
            "/chat/livechat/index"
        ];
        const pathName = window.location.pathname.toLowerCase();
        let isheadHide = false;
        if (validPaths.includes(pathName)) {
            isheadHide = true;
        }

        //Big3Common.GoodsDtl_ShowHide(true, isheadHide,"smilar_child_goods_dtl");

      
        //상세보기 호출
        Big3Common.WebConfig.SimilarUseYn = "Y";
        Big3Common.ModalClose(bootstrap, this.props.id);
        this.props.callBack({
            goods_no: list.goods_no,
            uid: list.uid,
            isshow: true,
            headhide: isheadHide,
            scrollevent: false
        });
        e.preventDefault();
    }
    Loading_render = (css) => {
        return (
            <div className={`img_search_result_box ${css}`}>
                <div className="search_loading">
                    <DotLottiePlayer
                        src={loading}
                        background="transparent"
                        loop
                        speed="1"
                        autoplay
                    >
                    </DotLottiePlayer>
                    <div className="text">AI로 유사 이미지 검색중입니다.<br />
                        잠시만 기다려주세요!
                    </div>
                </div>
            </div>
        )
    }
    Similarrender = () => {
        if (this.state.SimilarList.length > 0) {
            return (
                <div className="today_poroducts row row-cols-3 ">
                    {this.state.SimilarList.map(list =>
                        <div className="product" onClick={(e) => { this.handleGoodsDtl_Click(e, list) }} key={list.image_id}>
                            <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                            />
                            <div className="shop_name">{list.org_nm}</div>
                            <div className="product_name">{list.goods_nm}</div>
                            <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                        </div>
                    )}
                </div>
            )
        }
        else if (this.state.SimilarList.length === 0 && this.state.showLoading === false) {
            return (
                <div className="recent_product result_box" style={{ height: "240px" }}>
                    <div className="no_result" style={{ top: "60%" }}>
                        <div className="icon"></div>
                        <div className="text">검색결과가 없습니다.</div>
                    </div>
                </div>
            )
        }
        else {
            return (
                ""
            )
        }
    }
    render() {
        return (
            <> 
                <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id}
                    ref={this.refSimilarSearch}
                    data-bs-keyboard="false" data-bs-backdrop="static">
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content">
                            <div className="modal-header modal-header_v2">
                                <h4 className="modal-title h4">
                                    <div className="beta_tag"></div>
                                    AI가 찾은 유사 상품</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="img_thumnail_box">
                                <div className="thumnail_img" style={{ backgroundImage: `url(${this.state.ImageUrl})` }}></div>
                                <div className="img_info">
                                    <div className="shop_name">{this.state.ShopName}</div>
                                    <div className="product_name">{this.state.ProductName}</div>
                                </div>
                            </div>
                            <div className="folder_edit_box">
                                {this.Similarrender()}
                                {this.Loading_render(this.state.showLoading===true ? "" : "item_hide")}
                            </div>
                        </div>
                    </div>
                  
                </div>
               
            </>
        );
    }
}
